import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myLeftZerosRemove'
})
export class LeftZerosRemovePipe implements PipeTransform {

  transform(value) {
    if (value !== 0) {
      return parseInt(value, 10);
    }
    return value;
  }
}
